export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true" fill="none">
    <rect width="64" height="64" rx="14" fill="#1C1717" />
    <path d="M12 27c0-8 8-13 20-13s20 5 20 13H12Z" fill="#F59E0B" />
    <circle cx="24" cy="21" r="1.6" fill="#FAF6F0" />
    <circle cx="33" cy="18.5" r="1.6" fill="#FAF6F0" />
    <circle cx="41" cy="21.5" r="1.6" fill="#FAF6F0" />
    <path
      d="M10 32c5 3.5 9-2.5 14 1s9-3.5 14 0 9-2.5 14 1"
      stroke="#D92323"
      strokeWidth="3.5"
      strokeLinecap="round"
    />
    <rect x="12" y="38" width="40" height="6" rx="3" fill="#6B4226" />
    <path d="M12 47c0 5 4 8 10 8h20c6 0 10-3 10-8v-2H12v2Z" fill="#F59E0B" />
  </svg>
);

export const SauceDrip = ({ className = "" }) => (
  <svg
    viewBox="0 0 1440 70"
    preserveAspectRatio="none"
    className={className}
    aria-hidden="true"
    fill="currentColor"
  >
    <path d="M0,0 L1440,0 L1440,26 C1410,26 1410,52 1380,52 C1350,52 1350,26 1320,26 C1290,26 1290,64 1260,64 C1230,64 1230,26 1200,26 C1170,26 1170,46 1140,46 C1110,46 1110,26 1080,26 C1050,26 1050,58 1020,58 C990,58 990,26 960,26 C930,26 930,44 900,44 C870,44 870,26 840,26 C810,26 810,62 780,62 C750,62 750,26 720,26 C690,26 690,48 660,48 C630,48 630,26 600,26 C570,26 570,56 540,56 C510,56 510,26 480,26 C450,26 450,42 420,42 C390,42 390,26 360,26 C330,26 330,60 300,60 C270,60 270,26 240,26 C210,26 210,46 180,46 C150,46 150,26 120,26 C90,26 90,54 60,54 C30,54 30,26 0,26 Z" />
  </svg>
);

const base = "h-5 w-5";
export const IconPin = ({ className = base }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 1 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

export const IconInstagram = ({ className = base }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" />
  </svg>
);

export const IconArrowUpRight = ({ className = base }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 17 17 7" />
    <path d="M8 7h9v9" />
  </svg>
);

export const IconFlame = ({ className = base }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />
  </svg>
);

export const IconMenu = ({ className = base }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M4 7h16M4 12h16M4 17h16" />
  </svg>
);

export const IconClose = ({ className = base }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M6 6l12 12M18 6 6 18" />
  </svg>
);
